import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "src/helpers/FormHelper";
import { createBundle } from "src/actions/callrecorder/bundlesActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewError, setNewParams, BundleInterface } from "src/store/callrecorder/bundlesSlice";

import Form from './_partials/_Form';
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.callrecorder.bundles.newParams);
  const error = useAppSelector(state => state.callrecorder.bundles.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: BundleInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createBundle(data));

    if (createBundle.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-bundle'>
        <h6 className="v-content-label">Create Bundle</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
